export const INIT_STEPDATA = "INIT_STEPDATA"
export const START_STEP = "START_STEP"
export const STEP_SHOW_NEXT = "STEP_SHOW_NEXT"
export const COMPLETE_STEP = "COMPLETE_STEP"
export const INCREMENT_STEP = "INCREMENT_STEP"